import { compose } from 'redux';

import type { ChecklistsState } from '../checklistsStore';

export const selectChecklistsDomain = (state: ChecklistsState) =>
  state.checklists;

export const selectTemplateChecklistsWebData = compose(
  (state) => state.templateChecklistsWebData,
  selectChecklistsDomain
);

export const selectCompletedChecklistsWebData = compose(
  (state) => state.completedChecklistsWebData,
  selectChecklistsDomain
);

export const selectChecklistsNamesWebData = compose(
  (state) => state.completedChecklistsNamesWebData,
  selectChecklistsDomain
);

export const selectChecklistWebData = compose(
  (state) => state.checklistWebData,
  selectChecklistsDomain
);

export const selectSaveChecklistWebData = compose(
  (state) => state.saveChecklistWebData,
  selectChecklistsDomain
);

export const selectDeleteChecklistWebData = compose(
  (state) => state.deleteChecklistWebData,
  selectChecklistsDomain
);
